import * as React from 'react';

import { useModelPanelStack } from 'src/containers/ProjectModelDialog/hooks/useModelPanelStackValue';
import { useResetModelPanels } from 'src/containers/ProjectModelDialog/hooks/useResetModelPanels';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';

export const useCloseModelDialog = () => {
  const dispatch = useReduxDispatch();
  const { onReset } = useModelPanelStack();
  const resetModelPanels = useResetModelPanels();

  const handleClose = React.useCallback(() => {
    onReset();
    resetModelPanels();
    dispatch(uiSlice.actions.toggledProjectModelDialog({ isOpen: false }));
  }, [dispatch, onReset, resetModelPanels]);

  return handleClose;
};
